module.exports = __webpack_public_path__ + "img/old-logo-light.5fec7e6d.png";